import React, { useCallback } from 'react'
import { useState, useEffect, useRef } from 'react'
// import Searcher from "../../autocomplete"
// import SearchByAddress from "../../autocompleteAddress"
// import { useNavigate } from '@reach/router'
import { navigate } from 'gatsby'
import toast from 'react-hot-toast'
import {
  getChildrens,
  getFathers,
  getGrandfathers,
  getTypeCount,
  normalizeName,
} from '@helpers/helper.filters'
import $ from 'jquery'
import { Modal } from 'react-bootstrap'
import {
  FilterPropertiesTokkoQuery,
  RealEstateDataPageComponentData,
  SearcherFilterData,
  StatePropertiesSlice,
} from 'types'
import { useDispatch, useSelector } from 'react-redux'
import { Markup } from 'interweave'
import { reduxUpdateFilters, updateSearcherHome } from '@slices/propertiesSlice'
import useQuerySummary from '@hooks/useQuerySummary'
import { useGetAdvancedLocationsQuery, usePrefetch } from '@apis/middlewareTokkoApi/properties'
import useQuerySearcher from '@hooks/useQuerySearcher'
import Autocomplete_1 from '../autocomplete'
import { Collapse } from 'react-bootstrap'

// const isBrowser = typeof window !== 'undefined'

const Search_1 = ({
  global_data,
  button,
  is_short,
  backgroundSecondary,
  locationsAdv = true,
  alternativeButtons,
  is_bottom_searcher = false,
}: RealEstateDataPageComponentData) => {
  const dispatch = useDispatch()
  const API_KEY = global_data.pageConfig.keys.tokko

  const searchHome = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties.searchHome,
  )!

  const { filters, orders, offset, polygonCoordinates, coordinates } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!

  const icons = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const prefetch = usePrefetch('getProperties')

  const prefetchProperties = useCallback(() => {}, [prefetch])

  const [disabledPlaceholder, setDisabledPlaceholder] = useState({
    location: false,
    type: false,
    addres: false,
  })

  const [isMounted, setIsMounted] = useState(false)
  const [searcherType, setSearcherType] = useState('')
  const [openOperation, setOpenOperation] = useState(false)
  const [openType, setOpenType] = useState(false)
  const [openLocation, setOpenLocation] = useState(false)
  const [show, setShow] = useState({
    operation: false,
    location: false,
    type: false,
    address: false,
  })

  const { allSummaryData, isLoading: isLoadingAllSummaryData } = useQuerySummary({ API_KEY })
  const { data: dataLocations } = useGetAdvancedLocationsQuery({
    API_KEY: API_KEY,
    operation: searchHome.operation,
    types: searchHome.type,
  })
  const { allSummaryData: summaryByOperation } = useQuerySummary({
    OPERATION: searchHome.operation.toLowerCase(),
    API_KEY,
  })

  const { allSummaryData: mediacoreLocationTree } = useQuerySummary({
    OPERATION: searchHome.operation.toLowerCase(),
    TYPE: searchHome.type,
    API_KEY,
  })
  const handleClose = () =>
    setShow({ operation: false, location: false, type: false, address: false })

  const [errorInput] = useState(false)

  const [collapse_items, setCollapse_items] = useState<
    {
      id: string
      state: boolean
    }[]
  >([])

  const getStatusCollapse = (id: string) => {
    if (collapse_items?.find((item) => item.id === id)) {
      return collapse_items.find((item) => item.id === id)?.state
    }
    return false
  }

  const setStatusColapse = (id: string, state: boolean) => {
    if (!collapse_items?.find((item) => item.id === id)) {
      let items_in = collapse_items?.map((item) => item)
      items_in?.push({ id: id, state: true })
      return setCollapse_items(items_in)
    }
    let items = collapse_items?.map((item) => item)
    items?.forEach((item) => {
      if (item.id === id) {
        item.state = state
      }
    })
    setCollapse_items(items)
  }

  const [router, setRouter] = useState<SearcherFilterData>({
    location: [],
    type: [],
    operation: 'venta',
    address: '',
  })

  const updateRoute = (value: { current: { name: string; value: string } }) => {
    setRouter((router) => ({
      ...router,
      [value.current.name]: value.current.value,
    }))
  }

  const updateLocation = (value: { id: number; name: string }) => {
    if (value === undefined) {
      return null
    }
    const { id } = value

    if (searchHome.location.find((element) => element.id === id)) {
      dispatch(
        updateSearcherHome({
          ...searchHome,
          location: searchHome.location.filter((element) => element.id !== id),
        }),
      )
    } else {
      dispatch(
        updateSearcherHome({
          ...searchHome,
          location: [...searchHome.location, value],
        }),
      )
    }
  }

  useEffect(() => {
    handleTogglerSelect('')
    switch (router?.operation?.toLowerCase()) {
      case 'venta':
        updateOperation({ name: 'venta' })
        break
      case 'alquiler':
        updateOperation({ name: 'alquiler' })
        break
      case 'temporario':
        updateOperation({ name: 'temporario' })
        break
      default:
    }
  }, [router.operation])

  if (isMounted) {
    $(document).ready(function () {
      $(document).on('click', function (event) {
        if (!$(event.target).closest('.not-closer').length) {
          setOpenType(false)
          setOpenLocation(false)
          setOpenOperation(false)
        }
      })
    })
  }

  const goRoute = (event: any) => {
    event.preventDefault()
    let routerLink = searchHome?.operation?.toLowerCase()?.replace(/ /g, '-') ?? 'venta'
    routerLink +=
      searchHome.type.length > 0
        ? '/' +
          searchHome.type.map((element) =>
            element.name
              .toLowerCase()
              .replace(/ /g, '-')
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          )
        : ''

    routerLink +=
      searchHome.location.length > 0
        ? '/' +
          searchHome.location.map((element) =>
            element.name
              .toLowerCase()
              .replace(/ /g, '-')
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          )
        : ''
    routerLink += searchHome.address
      ? '/en-calle-' +
        searchHome.address
          .replaceAll(' ', '-')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      : ''
    console.log(routerLink)
    window.location.href = routerLink
  }

  const updateOperation = ({ name }: { name: string }) => {
    dispatch(
      updateSearcherHome({
        ...searchHome,
        operation: name,
        type: [],
        location: [],
        address: '',
      }),
    )
  }

  const handleTogglerSelect = (select: string) => {
    //Function to open/close custom-selects
    if (typeof window !== undefined) {
      setOpenLocation(false)
      setOpenType(false)
      setOpenOperation(false)
      switch (select) {
        case 'operation': {
          setOpenOperation(!openOperation)
          break
        }
        case 'location': {
          setOpenLocation(!openLocation)
          break
        }
        case 'type': {
          setOpenType(!openType)
          break
        }
        default: {
          break
        }
      }
      // }
      // else{
      // handleShow(select)
      // }
    }
  }

  const updateTypes = (value: { id: number; name: string }) => {
    if (searchHome.type.find((element) => element.id === value.id)) {
      dispatch(
        updateSearcherHome({
          ...searchHome,
          type: searchHome.type.filter((element) => element.id !== value.id),
        }),
      )
    } else {
      dispatch(
        updateSearcherHome({
          ...searchHome,
          type: [...searchHome.type, value],
        }),
      )
    }
  }

  function toMarkup(text: string, searcherOperation: string) {
    if (searcherOperation === '') {
      return text
    }
    text = text
      .toLowerCase()
      .replaceAll(searcherOperation.toLowerCase(), '<b>' + searcherOperation.toLowerCase() + '</b>')
    return text
  }

  // const checkResults = (type: string) => {
  const checkResults = (type: string) => {
    if (type === 'location') {
      for (let grandfather of getGrandfathers(dataLocations)) {
        if (grandfather[0].toLowerCase().includes(searcher.toLowerCase())) {
          return false
        }
        for (let father of getFathers(grandfather)) {
          if (father[0].toLowerCase().includes(searcher.toLowerCase())) {
            return false
          }
          for (let children of getChildrens(father)) {
            if (children[0].toLowerCase().includes(searcher.toLowerCase())) {
              return false
            }
          }
        }
      }
      return true
    } else {
      for (let type of summaryByOperation?.objects?.property_types) {
        if (type.type.toLowerCase().includes(searcherType.toLowerCase())) {
          return false
        }
      }
      return true
    }
  }

  const makeElipsisTextType = (text: string[], length: number) => {
    let resume = ''
    text.map((element: string) => (resume += element))
    if (resume.length > length) {
      return resume.slice(0, length) + '...'
    }
    return resume
  }

  const [searcher, setSearcher] = useState('')

  useEffect(() => {
    dispatch(updateSearcherHome({ ...searchHome, type: [], location: [] }))
    dispatch(reduxUpdateFilters({ ...filters, operation: searchHome.operation }))
    $('#type').val('all')
  }, [searchHome.operation])

  useEffect(() => {
    dispatch(updateSearcherHome({ ...searchHome, location: [] }))
    dispatch(reduxUpdateFilters({ ...filters, type: searchHome.type }))
  }, [searchHome.type])

  useEffect(() => {
    setSearcher('')
    dispatch(
      reduxUpdateFilters({
        ...filters,
        location: searchHome.location,
        address: searchHome.address,
      }),
    )
  }, [searchHome.location, searchHome.address])

  useEffect(() => {
    setdisabledsearch(true)
    dispatch(
      reduxUpdateFilters({
        location: [],
        type: [],
        operation: '',
        environments: '',
        bedrooms: '',
        age: '',
        address: '',
        producer_id: '',
        price: {
          type: '',
          priceMin: '',
          priceMax: '',
          is_off: false,
        },
        surface: {
          type: '',
          surfaceMin: '',
          surfaceMax: '',
        },
        environments_types: [],
        generals: [],
        services: [],
        specials: [],
      }),
    )
    dispatch(
      updateSearcherHome({
        // operation: 'venta',
        operation: is_short ? 'venta' : '',
        location: [],
        type: [],
        address: '',
      }),
    )
    // setRouter({ operation: 'venta', location: [], type: [], address: '' })
    setRouter({ operation: is_short ? 'venta' : '', location: [], type: [], address: '' })
    setTimeout(() => {
      setdisabledsearch(false)
    }, 10)
  }, [history])

  useEffect(() => {
    setIsMounted(true)
  }, [])

  function setActionType(e: { target: { value: string } }): void {
    setOpenType(true)
    setSearcherType(e.target.value)
  }

  const ButtonsOperationElement = () => {
    return (
      <div
        className="btn-group w-100"
        role="group"
        aria-label="Basic example"
      >
        {allSummaryData &&
        allSummaryData.objects.operation_types.find(
          (element: FilterPropertiesTokkoQuery) => element.operation_type === 1,
        ) ? (
          <button
            onClick={() =>
              updateRoute({
                current: { value: 'venta', name: 'operation' },
              })
            }
            type="button"
            className={`btn btn-primary ${alternativeButtons ? 'secondary-background' : ''} ${
              router?.operation?.toLowerCase() === 'venta' ? 'active' : ''
            }`}
          >
            {'Venta'}
          </button>
        ) : (
          ''
        )}
        {allSummaryData &&
        allSummaryData.objects.operation_types.find(
          (element: FilterPropertiesTokkoQuery) => element.operation_type === 2,
        ) ? (
          <button
            onClick={() =>
              updateRoute({
                current: { value: 'alquiler', name: 'operation' },
              })
            }
            type="button"
            className={`btn mx-auto btn-primary ${
              alternativeButtons ? 'secondary-background' : ''
            } ${router?.operation?.toLowerCase() === 'alquiler' ? 'active' : ''}`}
          >
            Alquiler
          </button>
        ) : (
          ''
        )}
        {allSummaryData &&
        allSummaryData.objects.operation_types.find(
          (element: FilterPropertiesTokkoQuery) => element.operation_type === 3,
        ) ? (
          <button
            onClick={() =>
              updateRoute({
                current: {
                  value: 'temporario',
                  name: 'operation',
                },
              })
            }
            type="button"
            className={
              'btn btn-primary ' +
              (router?.operation?.toLowerCase() === 'temporario' ? 'active' : '')
            }
          >
            Temporario
          </button>
        ) : (
          ''
        )}
      </div>
    )
  }

  const SelectsOperationElement = () => {
    return (
      <div className={'d-flex content-field content-select ' + (!openOperation && 'close')}>
        <input
          className={
            'dropdown-select operation border-round btn btn-main not-closer no-hover text-start br-true true ' +
            (router.operation ? 'text-capitalize' : 'text-none')
          }
          placeholder={router.operation || 'Tipo de operación'}
          style={{ textTransform: 'none' }}
          onClick={() =>
            window.screen.width < 992
              ? setShow({ ...show, operation: true })
              : handleTogglerSelect('operation')
          }
        />
        <div className="icon-arrow-light arrow"></div>
        <div className="float-select width-custom height-fixed">
          <div className={'my-wrapper position-relative '}>
            <div className={'flex-input d-none '}>
              <input
                type="radio"
                className="not-closer"
                id={'selector'}
                readOnly
                checked={router?.operation?.toLowerCase() === '' ? true : false}
                onClick={() => {
                  setOpenLocation(false)
                  updateRoute({
                    current: { value: '', name: 'operation' },
                  })
                }}
                value={''}
              />{' '}
              <label
                className="not-closer"
                htmlFor={'selector'}
              >
                <div className="circle custom-span "></div>
                <div
                  className="mark-up not-closer"
                  style={{ textTransform: 'none' }}
                >
                  Tipo de operación
                </div>
              </label>
            </div>
            {allSummaryData &&
            allSummaryData.objects.operation_types.find(
              (element: FilterPropertiesTokkoQuery) => element.operation_type === 1,
            ) ? (
              <div className={'flex-input '}>
                <input
                  type="radio"
                  className="not-closer"
                  id={'venta'}
                  checked={router?.operation?.toLowerCase() === 'venta' ? true : false}
                  onClick={() => {
                    setOpenLocation(false)
                    updateRoute({
                      current: { value: 'venta', name: 'operation' },
                    })
                  }}
                  value={'venta'}
                />
                <label
                  className={
                    'not-closer ' +
                    (router?.operation?.toLowerCase() === 'venta' ? 'active-label' : '')
                  }
                  htmlFor={'venta'}
                >
                  <div
                    className={
                      'circle custom-span ' +
                      (router?.operation?.toLowerCase() === 'venta' ? 'active-label' : '')
                    }
                  ></div>
                  <div className="mark-up not-closer">Venta</div>
                </label>
              </div>
            ) : (
              ''
            )}
            {allSummaryData &&
            allSummaryData.objects.operation_types.find(
              (element: FilterPropertiesTokkoQuery) => element.operation_type === 2,
            ) ? (
              <div className={'flex-input '}>
                <input
                  type="radio"
                  className="not-closer"
                  id={'alquiler'}
                  checked={router?.operation?.toLowerCase() === 'alquiler' ? true : false}
                  onClick={() => {
                    setOpenLocation(false)
                    updateRoute({
                      current: { value: 'alquiler', name: 'operation' },
                    })
                  }}
                  value={'alquiler'}
                />{' '}
                <label
                  className="not-closer"
                  htmlFor={'alquiler'}
                >
                  <div className="circle custom-span "></div>
                  <div className="mark-up not-closer">Alquiler</div>
                </label>
              </div>
            ) : (
              ''
            )}
            {allSummaryData &&
            allSummaryData.objects.operation_types.find(
              (element: FilterPropertiesTokkoQuery) => element.operation_type === 3,
            ) ? (
              <div className={'flex-input '}>
                <input
                  type="radio"
                  className="not-closer"
                  id={'temporario'}
                  checked={router?.operation?.toLowerCase() === 'temporario' ? true : false}
                  onClick={() => {
                    setOpenLocation(false)
                    updateRoute({
                      current: { value: 'temporario', name: 'operation' },
                    })
                  }}
                  value={'temporario'}
                />
                <label
                  className="not-closer"
                  htmlFor={'temporario'}
                >
                  <div className="circle custom-span "></div>
                  <div className="mark-up not-closer">Temporario</div>
                </label>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    )
  }

  const checkAllFatherActives = (item: any) => {
    // Se fija si todos los hijos de un abuelo estan activos
    const fathers: any = getFathers(item)
    for (const father of fathers) {
      if (searchHome.location.find((element) => element.id === father[1].id)) {
      } else {
        return false
      }
    }
    return true
  }

  const checkCitiesActive = (parent: any) => {
    // // Se fija si todos los hijos de un padre estan activos
    if (Object.keys(parent[1]).length === 2) {
      if (
        searchHome.location.find((location) => location.id.toString() === parent[1].id.toString())
      ) {
        return true
      }
      return false
    }
    const childrens: any = getChildrens(parent)
    for (const children of childrens) {
      if (searchHome.location.find((element) => element.id === children[1].id)) {
      } else {
        return false
      }
    }
    return true
  }

  const updateLocationByGrandFather = (item: any) => {
    const fathers: any = getFathers(item)
    const parentFormated = fathers.map(
      // Formateo todos los hijos de este abuelo.
      (element: { id: string; name: string }[]) => ({ id: element[1].id, name: element[0] }),
    )
    let newLocations = []
    for (let i = 0; i < searchHome.location.length; i++) {
      //Recorro los filtros activos para eliminar todos los hijos de este abuelo activo.
      if (parentFormated.find((element: any) => element.id === searchHome.location[i].id)) {
        //Si encuentro un hijo activo, no lo agrego.
      } else {
        newLocations.push({ id: searchHome.location[i].id, name: searchHome.location[i].name }) //Mantengo los filtros activos que no pertenecer a este abuelo.
      }
    }
    if (!checkAllFatherActives(item)) {
      newLocations = [...newLocations, ...parentFormated] //Si no estan todos los hijos de este abuelo activos, los activo.
    } else {
      for (let i = 0; i < getFathers(item).length; i++) {
        const father = getFathers(item)[i]
        for (let c = 0; c < getChildrens(father).length; c++) {
          const children: any = getChildrens(father)[c]
          newLocations = newLocations.filter((element) => element.id !== children[1].id) // Elimino los nietos que estan activos.
        }
      }
    }
    return dispatch(updateSearcherHome({ ...searchHome, location: newLocations })) // Si todos los los hijos de este abuelo están activos, los desactivo.
  }

  const updateLocationByParent = (item: any) => {
    let newLocations = searchHome.location
    for (let i = 0; i < getGrandfathers(dataLocations).length; i++) {
      // Me fijo si el abuelo tiene todos los hijos activos, los desactivo y activo solo este padre que estoy clickeando.
      if (getFathers(getGrandfathers(dataLocations)[i]).find((element) => element[0] === item[0])) {
        if (checkAllFatherActives(getGrandfathers(dataLocations)[i])) {
          //Si llegan a estar todos los hijos activos, los desactivo y dejo solo este activo.
          for (let j = 0; j < getFathers(getGrandfathers(dataLocations)[i]).length; j++) {
            // Recorro todos los "Hermanos" de este padre
            const brother: any = getFathers(getGrandfathers(dataLocations)[i])[j]
            for (let c = 0; c < getChildrens(brother).length; c++) {
              // Recorro los hijos de los hermanos y tambien los deshabilito.
              let children: any = getChildrens(brother)[c]
              newLocations = newLocations.filter((location) => location.id !== children[1].id)
            }
            newLocations = newLocations.filter((location) => location.id !== brother[1].id) //Saco todos los hermanos
          }
          const childrens: any = getChildrens(item)
          if (getChildrens(item).length > 0) {
            for (let c = 0; c < childrens.length; c++) {
              const children: any = getChildrens(item)[c]
              newLocations = [...newLocations, { id: children[1].id, name: children[0] }]
            }
            return dispatch(updateSearcherHome({ ...searchHome, location: newLocations })) //Si este padre tiene hijos, los activo a ellos.
          }
          return dispatch(
            updateSearcherHome({
              ...searchHome,
              location: [...newLocations, { id: item[1].id, name: item[0] }],
            }),
          ) //Si no tiene hijos, solo lo activo a el.
        }
      }
    }
    if (Object.keys(item[1]).length === 2) {
      // Si no tiene hijos el padre
      return updateLocation({ id: item[1].id, name: item[0] })
    }
    if (checkCitiesActive(item)) {
      // Si todos los hijos del padre están activos, los desactivo.
      const childrens: any = getChildrens(item)
      for (const children of childrens) {
        newLocations = newLocations.filter((element) => element.id !== children[1].id)
      }
      return dispatch(
        updateSearcherHome({
          ...searchHome,
          location: newLocations.filter((element) => element.id !== item[1].id),
        }),
      )
    } else {
      // Si hay algun hijo del padre no activo, activo todos los hijos de este padre
      const childrens: any = getChildrens(item)
      for (const children of childrens) {
        newLocations = newLocations.filter((element) => element.id !== children[1].id)
        newLocations.push({ id: children[1].id, name: children[0] })
      }
    }

    return dispatch(
      updateSearcherHome({
        ...searchHome,
        location: [...newLocations, { id: item[1].id, name: item[0] }],
      }),
    )
  }

  const makeElipsisText = (length: number) => {
    const actives = []
    let text_adapted = ''
    if (API_KEY) {
      const grandfathers: any = getGrandfathers(dataLocations)
      for (let grandfather of grandfathers) {
        if (checkAllFatherActives(grandfather)) {
          text_adapted += (text_adapted.length > 0 ? ', ' : '') + grandfather[0]
          actives.push({ name: grandfather[0], id: grandfather[1].id })
        } else {
          const fathers: any = getFathers(grandfather)
          for (let father of fathers) {
            if (checkCitiesActive(father)) {
              text_adapted += (text_adapted.length > 0 ? ', ' : '') + father[0]
              // actives.push(father[0])
              actives.push({ name: father[0], id: father[1].id })
            } else {
              const childrens: any = getChildrens(father)
              for (let children of childrens) {
                if (searchHome.location.find((element) => element.id === children[1].id)) {
                  text_adapted += (text_adapted.length > 0 ? ', ' : '') + children[0]
                  // actives.push(children[0])
                  actives.push({ name: children[0], id: children[1].id })
                }
              }
            }
          }
        }
      }
    } else {
      if (allSummaryData?.objects?.locations_tree) {
        for (let country of allSummaryData?.objects?.locations_tree) {
          for (let grandfather of country.data) {
            if (allNeighborhoodActivesByGrandfather(grandfather)) {
              text_adapted += (text_adapted.length > 0 ? ', ' : '') + grandfather.name
            } else {
              for (let father of grandfather.data) {
                if (allNeighborhoodActives(father)) {
                  text_adapted += (text_adapted.length > 0 ? ', ' : '') + father.name
                } else {
                  for (let children of father.data) {
                    if (searchHome.location.find((element) => element.name === children.name)) {
                      text_adapted += (text_adapted.length > 0 ? ', ' : '') + children.name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    if (text_adapted.length > length) {
      return text_adapted.slice(0, length) + '...'
    }
    return text_adapted || 'Ubicación'
  }

  const ComponentLocation = () => {
    return (
      <>
        <div className="float-select width-custom height-fixed">
          <div className={'my-wrapper position-relative '}>
            {searcher !== '' ? (
              <>
                {getGrandfathers(dataLocations).map((item) => (
                  <>
                    {item[0].toLowerCase().includes(searcher.toLowerCase()) && (
                      <div className="hover-white d-flex px-3 w-100 align-items-center justify-content-start my-1">
                        <label className={'option flex-input not-closer'}>
                          <input
                            checked={checkAllFatherActives(item) ? true : false}
                            onChange={() => updateLocationByGrandFather(item)}
                            id={item[0]}
                            type="checkbox"
                            className="radio-custom "
                            value={item[0]}
                          />
                          <span className="custom-input square"></span>{' '}
                          <div className="mark-up">
                            {' '}
                            <Markup content={toMarkup(item[0], searcher)} />
                          </div>
                        </label>
                      </div>
                    )}
                    {getFathers(item).map((father) => (
                      <>
                        {father[0].toLowerCase().includes(searcher.toLowerCase()) && (
                          <div className="d-flex px-3 w-100 align-items-center justify-content-start py-1">
                            <label className={'option flex-input'}>
                              <input
                                onChange={() => updateLocationByParent(father)}
                                checked={
                                  checkCitiesActive(father) && !checkAllFatherActives(item)
                                    ? true
                                    : false
                                }
                                id={father[0]}
                                type="checkbox"
                                className=" radio-custom"
                                value={father[0]}
                              />
                              <span className="custom-input square"></span>{' '}
                              <div className="mark-up">
                                {' '}
                                <Markup content={toMarkup(father[0], searcher)} />
                              </div>
                            </label>
                          </div>
                        )}
                        {getChildrens(father).map(
                          (children: any) =>
                            children[0].toLowerCase().includes(searcher.toLowerCase()) && (
                              <div className="d-flex px-lg-3 w-100 align-items-center py-1">
                                <label className={'option flex-input'}>
                                  <input
                                    id=""
                                    type="checkbox"
                                    checked={
                                      searchHome.location.find(
                                        (element) => element.id === children[1].id,
                                      ) && !checkAllFatherActives(item)
                                        ? true
                                        : false
                                    }
                                    onChange={() =>
                                      updateLocation({
                                        id: children[1].id,
                                        name: children[0],
                                      })
                                    }
                                    className="radio-custom"
                                    value={children[0]}
                                  />
                                  <span className="custom-input square"></span>{' '}
                                  <div className="mark-up">
                                    {' '}
                                    <Markup content={toMarkup(children[0], searcher)} />
                                  </div>
                                </label>
                              </div>
                            ),
                        )}
                      </>
                    ))}
                  </>
                ))}
                {/* {checkResults('location') && (
            <span className="mb-4">
              No hay resultados sobre <b> "{searcher}"</b>.
            </span>
          )} */}
              </>
            ) : (
              getGrandfathers(dataLocations).map(
                (
                  item,
                  i, // List the grandfathers
                ) => (
                  <div
                    key={i}
                    className={''}
                  >
                    <div className="hover-white d-flex px-lg-3 w-100 align-items-center justify-content-start w-custom my-1 py-0 mb-0">
                      <div
                        className={'me-2 open-collapse collapsed d-inline-flex'}
                        data-bs-toggle="collapse"
                        data-bs-target={'#collapse-location-gf-' + normalizeName(item[0])}
                      ></div>
                      <label className={'mb-0 option flex-input not-closer'}>
                        <input
                          onChange={() => updateLocationByGrandFather(item)}
                          checked={checkAllFatherActives(item) ? true : false}
                          id=""
                          type="checkbox"
                          className="radio-custom "
                          value={item[0]}
                        />
                        <span className="custom-input square"></span>{' '}
                        {item[0].replace('**(.*)**', '<b>$1</b>')}
                      </label>
                    </div>
                    <div
                      className="detail-collapse ps-4 not-height collapse "
                      id={'collapse-location-gf-' + normalizeName(item[0])}
                    >
                      {getFathers(item).map(
                        (
                          father,
                          index, // List the fathers
                        ) => (
                          <div
                            key={index}
                            className="d-flex flex-column justify-content-content mb-0 align-items-start w-custom py-0"
                          >
                            <div className="ps-2 ps-lg-4 hover-white d-flex align-items-center w-100 justify-content-center ">
                              <div
                                className={
                                  'me-2 open-collapse collapsed d-inline-flex ' +
                                  (getChildrens(father).length <= 1 ? ' opacity-button ' : '')
                                }
                                data-bs-toggle="collapse"
                                data-bs-target={'#collapse-location-ft-' + normalizeName(father[0])}
                              ></div>
                              <label className={'option flex-input'}>
                                <input
                                  id={normalizeName(father[0])}
                                  onClick={() => updateLocationByParent(father)}
                                  checked={
                                    checkCitiesActive(father) && !checkAllFatherActives(item)
                                      ? true
                                      : false
                                  }
                                  readOnly
                                  type="checkbox"
                                  className="radio-custom"
                                />
                                <span className="custom-input square"></span> {father[0]}
                              </label>
                            </div>
                            {/* <div
                              className="detail-collapse ps-5 ps-lg-4  w-100 children not-height collapse mb-2"
                              id={'collapse-location-ft-' + normalizeName(father[0])}
                            >
                              {getChildrens(father).map(
                                (
                                  children: any,
                                  index: number, // List the childrens
                                ) => (
                                  <label
                                    key={index}
                                    htmlFor={children[1].id}
                                    className={'childrens-inputs option hover-white flex-input'}
                                  >
                                    <input
                                      id={children[1].id}
                                      type="checkbox"
                                      checked={
                                        searchHome.location.find(
                                          (element) => element.id === children[1].id,
                                        ) && !checkAllFatherActives(item)
                                          ? true
                                          : false
                                      }
                                      onChange={() =>
                                        updateLocation({
                                          id: children[1].id,
                                          name: children[0],
                                        })
                                      }
                                      className="radio-custom"
                                      value={children[0]}
                                    />
                                    <span className="custom-input square"></span> {children[0]}
                                  </label>
                                ),
                              )}
                            </div> */}
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                ),
              )
            )}
          </div>
        </div>
      </>
    )
  }

  const updateLocationByGrandFatherMediacore = (grandfather: any) => {
    let newLocations = filters.location
    console.log('actual')
    console.log(newLocations)
    let flag = false
    for (let index = 0; index < grandfather.data.length; index++) {
      const loc_father = grandfather.data[index]
      if (allNeighborhoodActivesByGrandfather(grandfather)) {
        const loc_neighborhoods = loc_father.data
        for (let index_nei = 0; index_nei < loc_neighborhoods.length; index_nei++) {
          const loc_neighborhood = loc_father.data[index_nei]
          newLocations = newLocations.filter((loc) => loc.name !== loc_neighborhood.name)
        }
      } else {
        console.log(grandfather.data)
        const loc_neighborhoods = loc_father.data
        for (let index_nei = 0; index_nei < loc_neighborhoods.length; index_nei++) {
          const loc_neighborhood = loc_father.data[index_nei]
          newLocations = [...newLocations, { name: loc_neighborhood.name, type: 'neighborhood' }]
        }
      }
    }
    // return updateFilters(setFilters, filters, "allLocations", newLocations)
    return dispatch(updateSearcherHome({ ...searchHome, location: newLocations }))
  }
  const updateLocationByFatherMediacore = (father: any, grandfather: any) => {
    let newLocations = filters.location
    if (allNeighborhoodActivesByGrandfather(grandfather)) {
      for (let index = 0; index < grandfather.data.length; index++) {
        const loc_fathers = grandfather.data[index]
        const loc_neighborhoods = loc_fathers.data
        for (let index_nei = 0; index_nei < loc_neighborhoods.length; index_nei++) {
          const loc_neighborhood = loc_fathers.data[index_nei]
          newLocations = newLocations.filter((loc) => loc.name !== loc_neighborhood.name)
        }
      }
      for (let index = 0; index < father.data.length; index++) {
        const loc_father = father.data[index]
        newLocations = [...newLocations, { name: loc_father.name, type: 'neighborhood' }]
      }
    } else {
      if (allNeighborhoodActives(father)) {
        for (let index = 0; index < father.data.length; index++) {
          const loc_father = father.data[index]
          newLocations = newLocations.filter((loc) => loc.name !== loc_father.name)
        }
      } else {
        for (let index = 0; index < father.data.length; index++) {
          const loc_father = father.data[index]
          newLocations = [...newLocations, { name: loc_father.name, type: 'neighborhood' }]
        }
      }
    }
    // return updateFilters(setFilters, filters, "allLocations", newLocations)
    return dispatch(updateSearcherHome({ ...searchHome, location: newLocations }))
  }
  const updateLocationByChildrenMediacore = (children: { name: string | undefined }) => {
    let newLocations = []
    if (filters.location.find((loc) => loc.name === children.name)) {
      newLocations = filters.location.filter((loc) => loc.name !== children.name) //desactivo el abuelo si esta activo
    } else {
      newLocations = [...filters.location, { name: children.name, type: 'neighborhood' }] //activo el abuelo si esta activo
    }
    // return updateFilters(setFilters, filters, "allLocations", newLocations)
    return dispatch(updateSearcherHome({ ...searchHome, location: newLocations }))
  }

  const allNeighborhoodActives = (father: any) => {
    for (let index = 0; index < father.data.length; index++) {
      const loc_neighborhood = father.data[index]
      if (!filters.location.find((loc) => loc.name === loc_neighborhood.name)) {
        return false
      }
    }
    return true
  }

  const allNeighborhoodActivesByGrandfather = (grandfather: any) => {
    for (let index = 0; index < grandfather.data.length; index++) {
      const father = grandfather.data[index]
      if (!allNeighborhoodActives(father)) {
        return false
      }
    }
    return true
  }

  const [disabledsearcher, setdisabledsearch] = useState(false)

  return (
    !disabledsearcher && (
      <div
        className={
          ' search-home g d-flex align-items-center py-3  ' +
          (backgroundSecondary ? 'background-transparent ' : 'background-solid ') +
          (locationsAdv ? ' pro-searcher py-lg-0 ' : ' lite-searcher py-lg-0 ') +
          (isLoadingAllSummaryData && ' skeleton')
        }
      >
        <div
          className={`container-fluid ${alternativeButtons ? 'blur-background' : ''} `}
          style={{ maxWidth: '100%' }}
        >
          <form
            onSubmit={goRoute}
            className="row justify-content-center no-gutters align-items-stretch px-lg-1 pe-lg-0 px-4 search-form mb-0"
          >
            <div className="column-1 px-0">
              <div className="row">
                <div className={locationsAdv ? 'col-lg-6' : 'col-lg-7'}>
                  <div className="row">
                    <div
                      className={
                        'col-12 px-2 pr-lg-3 ' + (backgroundSecondary ? 'col-lg-7' : 'col-lg-6')
                      }
                    >
                      <div onClick={() => setdisabledsearch(true)}></div>
                      {is_short ? <ButtonsOperationElement /> : <SelectsOperationElement />}
                    </div>
                    <div
                      className={
                        'col-12 px-2 pr-lg-3 ps-lg-1 ' +
                        (backgroundSecondary ? 'col-lg-5' : 'col-lg-6')
                      }
                      style={{ zIndex: 10 }}
                    >
                      <div
                        className={
                          'd-flex content-field align-items-center content-select ' +
                          (!openType && 'close')
                        }
                      >
                        <div
                          onClick={() =>
                            toast.error('Debes primero seleccionar un tipo de operación.')
                          }
                          className={
                            'z-index-top ' + (searchHome.operation === '' ? 'd-block' : 'd-none')
                          }
                        ></div>
                        <input
                          type="text"
                          name="search-type"
                          value={searcherType}
                          onChange={(e) => setActionType(e)}
                          onFocus={() =>
                            setDisabledPlaceholder({ ...disabledPlaceholder, type: true })
                          }
                          onBlur={() =>
                            setDisabledPlaceholder({ ...disabledPlaceholder, type: false })
                          }
                          placeholder={
                            searchHome.type.length > 0
                              ? makeElipsisTextType(
                                  searchHome.type.map(
                                    (element, index) =>
                                      element.name +
                                      (index < searchHome.type.length - 1 ? ', ' : ''),
                                  ),
                                  25,
                                )
                              : disabledPlaceholder.type
                              ? ''
                              : 'Tipo de propiedad'
                          }
                          className={`dropdown-select border-round btn btn-main no-hover text-start br-true true text-black not-closer ${
                            backgroundSecondary ? 'left-alignment' : ''
                          }`}
                          onClick={(e) => (
                            window.screen.width < 992
                              ? setShow({ ...show, type: true })
                              : handleTogglerSelect('type'),
                            e.preventDefault()
                          )}
                        />
                        <i className="not-closer"></i>
                        <div className="float-select width-custom height-fixed">
                          <div className={'my-wrapper position-relative '}>
                            {summaryByOperation ? (
                              <>
                                {summaryByOperation.objects.property_types.map(
                                  (item: FilterPropertiesTokkoQuery, index: string) =>
                                    searcherType !== '' ? (
                                      <>
                                        {item
                                          .type!.toLowerCase()
                                          .includes(searcherType.toLowerCase()) && (
                                          <div
                                            key={index}
                                            className={
                                              'flex-input ' +
                                              (isLoadingAllSummaryData &&
                                              !searchHome.type.find(
                                                (element) => element.id === item.id,
                                              )
                                                ? 'disabled '
                                                : '') +
                                              (getTypeCount(summaryByOperation.objects, item) ===
                                                0 && 'opacity-filter')
                                            }
                                          >
                                            <input
                                              disabled={isLoadingAllSummaryData}
                                              type="checkbox"
                                              className="not-closer"
                                              onChange={() =>
                                                updateTypes({
                                                  id: item.id!,
                                                  name: item.type!,
                                                })
                                              }
                                              id={item.type + '-input'}
                                              value={item.type}
                                            />
                                            <label
                                              className="not-closer"
                                              htmlFor={item.type + '-input'}
                                            >
                                              <div className="square custom-span "></div>
                                              <div className="mark-up text-capitalize not-closer">
                                                {' '}
                                                <Markup
                                                  content={toMarkup(item.type!, searcherType)}
                                                />
                                              </div>
                                            </label>
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <div
                                        key={index}
                                        className={
                                          'flex-input ' +
                                          (isLoadingAllSummaryData &&
                                          !searchHome.type.find((element) => element.id === item.id)
                                            ? 'disabled '
                                            : '') +
                                          (getTypeCount(summaryByOperation.objects, item) === 0 &&
                                            'opacity-filter')
                                        }
                                      >
                                        <input
                                          disabled={isLoadingAllSummaryData}
                                          type="checkbox"
                                          className="not-closer"
                                          checked={
                                            searchHome.type.find(
                                              (element) => element.id === item.id,
                                            )?.id !== undefined && !isLoadingAllSummaryData
                                              ? true
                                              : false
                                          }
                                          onChange={() =>
                                            updateTypes({
                                              id: item.id!,
                                              name: item.type!,
                                            })
                                          }
                                          id={item.type + '-single'}
                                          value={item.type}
                                        />
                                        <label
                                          className="not-closer"
                                          htmlFor={item.type + '-single'}
                                        >
                                          <div className="square custom-span "></div>
                                          <div className="mark-up not-closer">
                                            {' '}
                                            <Markup content={toMarkup(item.type!, searcherType)} />
                                          </div>
                                        </label>
                                      </div>
                                    ),
                                )}
                                {checkResults('type') && searcherType !== '' && (
                                  <span className="mb-4">
                                    No hay resultados sobre <b> "{searcherType}"</b>.
                                  </span>
                                )}
                                <div className="control-float position-sticky w-100 d-flex justify-content-between ">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      dispatch(updateSearcherHome({ ...searchHome, type: [] }))
                                    }
                                    className="btn btn-primary border not-closer"
                                  >
                                    Limpiar
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => setOpenType(false)}
                                    className="btn btn-primary"
                                  >
                                    Aplicar
                                  </button>
                                </div>
                              </>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                        <div className="icon-arrow-light arrow">
                          {/* <i></i>
                          <i></i> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={locationsAdv ? 'col-lg-6' : 'col-lg-5'}
                  style={{ zIndex: 1 }}
                >
                  <div
                    className={
                      'row d-flex align-items-stretch ' + (locationsAdv ? 'no-gutters' : '')
                    }
                  >
                    <div
                      className={
                        'content-field col-12 px-2  ' +
                        (!openLocation && ' close') +
                        (locationsAdv ? ' col-lg-6 pe-lg-0 ' : ' col-lg-12')
                      }
                    >
                      <div className="icon-arrow-light arrow arrow-location"></div>
                      <div
                        className={
                          'content-select align-items-center d-flex w-100 ' +
                          (errorInput ? 'error-border' : '')
                        }
                      >
                        <div
                          onClick={() =>
                            toast.error('Debes primero seleccionar un tipo de operación.')
                          }
                          className={
                            'z-index-top ' + (searchHome.operation === '' ? 'd-block' : 'd-none')
                          }
                        ></div>
                        {locationsAdv ? (
                          <>
                            <i className={'icon-location' + iconsStyle}></i>

                            <input
                              type="text"
                              name="search-location"
                              id={'searcher-location'}
                              value={searcher}
                              onChange={(e) => {
                                setSearcher(e.target.value)
                              }}
                              onFocus={() =>
                                setDisabledPlaceholder({ ...disabledPlaceholder, location: true })
                              }
                              onBlur={() =>
                                setDisabledPlaceholder({ ...disabledPlaceholder, location: false })
                              }
                              placeholder={disabledPlaceholder.location ? '' : makeElipsisText(45)}
                              className={`input-with-icon dropdown-select border-round btn btn-main no-hover text-start br-true true not-closer ${
                                backgroundSecondary ? 'left-alignment' : ''
                              }`}
                              onClick={(e) => (
                                window.screen.width < 992
                                  ? setShow({ ...show, location: true })
                                  : handleTogglerSelect('location'),
                                e.preventDefault()
                              )}
                            />
                            <>
                              <div className="float-select width-custom height-fixed">
                                <div className={'my-wrapper position-relative '}>
                                  {searcher !== '' ? (
                                    <>
                                      {getGrandfathers(dataLocations).map((item) => (
                                        <>
                                          {item[0]
                                            .toLowerCase()
                                            .includes(searcher.toLowerCase()) && (
                                            <div className="hover-white not-closer d-flex px-3 w-100 align-items-center justify-content-start my-1">
                                              <label className={'option flex-input not-closer'}>
                                                <input
                                                  checked={
                                                    checkAllFatherActives(item) ? true : false
                                                  }
                                                  onChange={() => updateLocationByGrandFather(item)}
                                                  id={item[0]}
                                                  type="checkbox"
                                                  className="radio-custom "
                                                  value={item[0]}
                                                />
                                                <span className="custom-input not-closer square"></span>{' '}
                                                <div className="mark-up">
                                                  {' '}
                                                  <Markup content={toMarkup(item[0], searcher)} />
                                                </div>
                                              </label>
                                            </div>
                                          )}
                                          {getFathers(item).map((father) => (
                                            <>
                                              {father[0]
                                                .toLowerCase()
                                                .includes(searcher.toLowerCase()) && (
                                                <div className="d-flex px-3 w-100 not-closer align-items-center justify-content-start py-1">
                                                  <label className={'option flex-input not-closer'}>
                                                    <input
                                                      onChange={() =>
                                                        updateLocationByParent(father)
                                                      }
                                                      checked={
                                                        checkCitiesActive(father) &&
                                                        !checkAllFatherActives(item)
                                                          ? true
                                                          : false
                                                      }
                                                      id={father[0]}
                                                      type="checkbox"
                                                      className=" radio-custom"
                                                      value={father[0]}
                                                    />
                                                    <span className="custom-input square"></span>{' '}
                                                    <div className="mark-up">
                                                      {' '}
                                                      <Markup
                                                        content={toMarkup(father[0], searcher)}
                                                      />
                                                    </div>
                                                  </label>
                                                </div>
                                              )}
                                              {getChildrens(father).map(
                                                (children: any) =>
                                                  children[0]
                                                    .toLowerCase()
                                                    .includes(searcher.toLowerCase()) && (
                                                    <div className="d-flex px-lg-3 w-100 not-closer align-items-center py-1">
                                                      <label
                                                        className={'option not-closer flex-input'}
                                                      >
                                                        <input
                                                          id=""
                                                          type="checkbox"
                                                          checked={
                                                            searchHome.location.find(
                                                              (element) =>
                                                                element.id === children[1].id,
                                                            ) && !checkAllFatherActives(item)
                                                              ? true
                                                              : false
                                                          }
                                                          onChange={() =>
                                                            updateLocation({
                                                              id: children[1].id,
                                                              name: children[0],
                                                            })
                                                          }
                                                          className="radio-custom"
                                                          value={children[0]}
                                                        />
                                                        <span className="custom-input square"></span>{' '}
                                                        <div className="mark-up">
                                                          {' '}
                                                          <Markup
                                                            content={toMarkup(
                                                              children[0],
                                                              searcher,
                                                            )}
                                                          />
                                                        </div>
                                                      </label>
                                                    </div>
                                                  ),
                                              )}
                                            </>
                                          ))}
                                        </>
                                      ))}
                                      {/* {checkResults('location') && (
            <span className="mb-4">
              No hay resultados sobre <b> "{searcher}"</b>.
            </span>
          )} */}
                                    </>
                                  ) : API_KEY ? (
                                    getGrandfathers(dataLocations).map(
                                      (
                                        item,
                                        i, // List the grandfathers
                                      ) => (
                                        <div
                                          key={i}
                                          className={''}
                                        >
                                          <div className="hover-white d-flex px-lg-3 w-100 align-items-center justify-content-start w-custom my-1 py-0 mb-0">
                                            <div
                                              className={
                                                'me-2 not-closer open-collapse collapsed d-inline-flex'
                                              }
                                              data-bs-toggle="collapse"
                                              data-bs-target={
                                                '#collapse-location-gf-' + normalizeName(item[0])
                                              }
                                            ></div>
                                            <label className={'mb-0 option flex-input not-closer'}>
                                              <input
                                                onChange={() => updateLocationByGrandFather(item)}
                                                checked={checkAllFatherActives(item) ? true : false}
                                                id=""
                                                type="checkbox"
                                                className="radio-custom "
                                                value={item[0]}
                                              />
                                              <span className="custom-input square"></span>{' '}
                                              {item[0].replace('**(.*)**', '<b>$1</b>')}
                                            </label>
                                          </div>
                                          <div
                                            className="detail-collapse not-closer ps-4 ps-lg- not-height collapse "
                                            id={'collapse-location-gf-' + normalizeName(item[0])}
                                          >
                                            {getFathers(item).map(
                                              (
                                                father,
                                                index, // List the fathers
                                              ) => (
                                                <div
                                                  key={index}
                                                  className="d-flex flex-column justify-content-content mb-0 align-items-start w-custom py-0"
                                                >
                                                  <div className="ps-2 ps-lg-5 not-closer hover-white d-flex align-items-center w-100 justify-content-center ">
                                                    <div
                                                      className={
                                                        'me-2 open-collapse not-closer collapsed d-inline-flex ' +
                                                        (getChildrens(father).length <= 1
                                                          ? ' opacity-button '
                                                          : '')
                                                      }
                                                      data-bs-toggle="collapse"
                                                      data-bs-target={
                                                        '#collapse-location-ft-' +
                                                        normalizeName(father[0])
                                                      }
                                                    ></div>
                                                    <label className={'option flex-input'}>
                                                      <input
                                                        id={normalizeName(father[0])}
                                                        onClick={() =>
                                                          updateLocationByParent(father)
                                                        }
                                                        checked={
                                                          checkCitiesActive(father) &&
                                                          !checkAllFatherActives(item)
                                                            ? true
                                                            : false
                                                        }
                                                        readOnly
                                                        type="checkbox"
                                                        className="radio-custom"
                                                      />
                                                      <span className="custom-input square"></span>{' '}
                                                      {father[0]}
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="detail-collapse ps-5 ps-lg-0  w-100 children not-height collapse mb-2"
                                                    id={
                                                      'collapse-location-ft-' +
                                                      normalizeName(father[0])
                                                    }
                                                  >
                                                    {getChildrens(father).map(
                                                      (
                                                        children: any,
                                                        index: number, // List the childrens
                                                      ) => (
                                                        <label
                                                          key={index}
                                                          htmlFor={children[1].id}
                                                          className={
                                                            'childrens-inputs option hover-white flex-input'
                                                          }
                                                        >
                                                          <input
                                                            id={children[1].id}
                                                            type="checkbox"
                                                            checked={
                                                              searchHome.location.find(
                                                                (element) =>
                                                                  element.id === children[1].id,
                                                              ) && !checkAllFatherActives(item)
                                                                ? true
                                                                : false
                                                            }
                                                            onChange={() =>
                                                              updateLocation({
                                                                id: children[1].id,
                                                                name: children[0],
                                                              })
                                                            }
                                                            className="radio-custom"
                                                            value={children[0]}
                                                          />
                                                          <span className="custom-input square"></span>{' '}
                                                          {children[0]}
                                                        </label>
                                                      ),
                                                    )}
                                                  </div>
                                                </div>
                                              ),
                                            )}
                                          </div>
                                        </div>
                                      ),
                                    )
                                  ) : (
                                    mediacoreLocationTree?.objects?.locations_tree?.map(
                                      (country: any) =>
                                        country.data.map((grandfather: any, index: number) => (
                                          <div
                                            key={index}
                                            className={''}
                                          >
                                            <div className="d-flex mt-2 px-lg-3 w-100 align-items-center not-closer justify-content-start w-custom">
                                              <div
                                                className={
                                                  'me-2 open-collapse not-closer d-inline-flex ' +
                                                  (!getStatusCollapse(
                                                    normalizeName(grandfather.name),
                                                  )
                                                    ? 'collapsed'
                                                    : '')
                                                }
                                                aria-controls={
                                                  'collapse-location-' +
                                                  normalizeName(grandfather.name) +
                                                  index
                                                }
                                                aria-expanded={getStatusCollapse(
                                                  normalizeName(grandfather.name),
                                                )}
                                                onClick={() =>
                                                  setStatusColapse(
                                                    normalizeName(grandfather.name),
                                                    !getStatusCollapse(
                                                      normalizeName(grandfather.name),
                                                    ),
                                                  )
                                                }
                                              >
                                                <div className={'symbol not-closer'}></div>{' '}
                                              </div>
                                              <label
                                                className={'mb-0 option flex-input not-closer'}
                                              >
                                                <input
                                                  onChange={() =>
                                                    updateLocationByGrandFatherMediacore(
                                                      grandfather,
                                                    )
                                                  }
                                                  checked={allNeighborhoodActivesByGrandfather(
                                                    grandfather,
                                                  )}
                                                  id=""
                                                  type="checkbox"
                                                  className="radio-custom not-closer "
                                                  name="location[]"
                                                  value={grandfather.name}
                                                />
                                                <span className="custom-input not-closer square"></span>{' '}
                                                {grandfather.name.replace('**(.*)**', '<b>$1</b>')}{' '}
                                              </label>
                                            </div>
                                            <Collapse
                                              in={getStatusCollapse(
                                                normalizeName(grandfather.name),
                                              )}
                                            >
                                              <div
                                                className="detail-collapse not-height not-closer "
                                                id={
                                                  'collapse-location-' +
                                                  normalizeName(grandfather.name) +
                                                  index
                                                }
                                              >
                                                {grandfather.data.map(
                                                  (
                                                    father: any, // List the fathers
                                                    index: number,
                                                  ) => (
                                                    <div
                                                      key={index}
                                                      className="d-flex flex-column justify-content-content mb-0 align-items-start not-closer w-custom childrens"
                                                    >
                                                      <div className="d-flex ps-lg-4 align-items-center w-100 justify-content-center not-closer ">
                                                        <div
                                                          className={
                                                            'me-2 not-closer open-collapse d-inline-flex ' +
                                                            (father.data.length <= 1
                                                              ? ' opacity '
                                                              : '') +
                                                            (!getStatusCollapse(
                                                              normalizeName(father.name),
                                                            )
                                                              ? 'collapsed'
                                                              : '')
                                                          }
                                                          aria-controls={
                                                            'collapse-location-' +
                                                            normalizeName(father.name) +
                                                            index
                                                          }
                                                          aria-expanded={getStatusCollapse(
                                                            normalizeName(father.name),
                                                          )}
                                                          onClick={() =>
                                                            setStatusColapse(
                                                              normalizeName(father.name),
                                                              !getStatusCollapse(
                                                                normalizeName(father.name),
                                                              ),
                                                            )
                                                          }
                                                        >
                                                          <div
                                                            className={'symbol not-closer'}
                                                          ></div>{' '}
                                                        </div>
                                                        <label
                                                          className={
                                                            'option mb-1 not-closer flex-input'
                                                          }
                                                        >
                                                          {/* +  updateFilters(setFilters,filters,"location", {id:father[1].id,name:father[0]}) */}
                                                          <input
                                                            checked={
                                                              allNeighborhoodActives(father) &&
                                                              !allNeighborhoodActivesByGrandfather(
                                                                grandfather,
                                                              )
                                                            }
                                                            onChange={() =>
                                                              updateLocationByFatherMediacore(
                                                                father,
                                                                grandfather,
                                                              )
                                                            }
                                                            type="checkbox"
                                                            className="not-closer radio-custom"
                                                            name="location[]"
                                                            value={father.name}
                                                          />
                                                          <span className="not-closer custom-input square my-0"></span>{' '}
                                                          {father.name}
                                                        </label>
                                                      </div>
                                                      <Collapse
                                                        in={getStatusCollapse(
                                                          normalizeName(father.name),
                                                        )}
                                                      >
                                                        <div
                                                          className="detail-collapse ps-5 children not-height not-closer mb-2 childrens"
                                                          id={
                                                            'collapse-location-' +
                                                            normalizeName(father.name) +
                                                            index
                                                          }
                                                        >
                                                          {father.data.map(
                                                            (
                                                              children: any, // List the childrens
                                                              index: number,
                                                            ) => (
                                                              <label
                                                                key={index}
                                                                className={
                                                                  'not-closer ps-3 mb-1 option flex-input'
                                                                }
                                                              >
                                                                <input
                                                                  id=""
                                                                  type="checkbox"
                                                                  checked={
                                                                    filters.location.find(
                                                                      (element) =>
                                                                        element.name ===
                                                                        children.name,
                                                                    )
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  onChange={() =>
                                                                    updateLocationByChildrenMediacore(
                                                                      children,
                                                                    )
                                                                  }
                                                                  className="not-closer radio-custom"
                                                                  name="location[]"
                                                                  value={children.name}
                                                                />
                                                                <span className="not-closer  custom-input square my-0"></span>{' '}
                                                                {children.name}
                                                              </label>
                                                            ),
                                                          )}
                                                        </div>
                                                      </Collapse>
                                                    </div>
                                                  ),
                                                )}
                                              </div>
                                            </Collapse>
                                          </div>
                                        )),
                                    )
                                  )}
                                </div>
                              </div>
                            </>
                            {/* <ComponentLocation /> */}
                          </>
                        ) : (
                          // <div></div>
                          <Autocomplete_1
                            lang={summaryByOperation?.objects?.locations.map(
                              (item: any) => item.location_name,
                            )}
                            updateRoute={updateRoute}
                            searchHome={searchHome}
                          />
                        )}
                      </div>
                    </div>
                    {locationsAdv && (
                      <div
                        className="col-lg-6 px-2 px-lg-3"
                        onClick={(e) => (
                          window.screen.width < 992 ? setShow({ ...show, address: true }) : '',
                          e.preventDefault()
                        )}
                      >
                        <AddresAutocomplete
                          iconsStyle={iconsStyle}
                          API_KEY={API_KEY}
                          handleTogglerSelect={handleTogglerSelect}
                          alignLeft={!!backgroundSecondary}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={'column-2 position-relative my-lg-0 px-2 px-lg-0 pe-lg-0'}>
              <div
                onClick={() => toast.error('Debes primero seleccionar un tipo de operación.')}
                className={'z-index-top ' + (searchHome.operation === '' ? 'd-block' : 'd-none')}
              ></div>
              <button
                disabled={router.operation === '' ? true : false}
                onMouseEnter={prefetchProperties}
                className={`w-100 px-lg-3 d-flex align-items-center justify-content-center justify-content-lg-around btn btn-white search-btn ${
                  alternativeButtons ? 'secondary-background' : ''
                }`}
              >
                {button?.value || 'Buscar'}

                <i className={'ms-3 ms-lg-0 icon-search' + iconsStyle}></i>
              </button>
            </div>
          </form>
        </div>
        <Modal
          show={show.address}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          style={{ zIndex: 999999999 }}
          aria-labelledby="contained-modal-title-vcenter"
          contentClassName="is-modal-seacher address-modal position-fixed modal-mobile body-no-padding"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Buscar por dirección</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <input type="text" className="w-100 search-mobile" name="search-type" value={searcherType} placeholder={"Buscar por tipo"} onChange={(e) => setSearcherType(e.target.value)} /> */}
            <div className="float-select width-custom height-fixed py-3">
              <AddresAutocomplete
                iconsStyle={iconsStyle}
                API_KEY={API_KEY}
                handleTogglerSelect={handleTogglerSelect}
                alignLeft={!!backgroundSecondary}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div
              className="control-float position-sticky w-100 d-flex justify-content-end not-closer"
              style={{ maxWidth: 'none' }}
            >
              <button
                type="button"
                onClick={() => setShow({ ...show, address: false })}
                className="btn btn-primary not-closer"
              >
                <label> Aplicar</label>
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal
          show={show.operation}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          style={{ zIndex: 999999999 }}
          aria-labelledby="contained-modal-title-vcenter"
          contentClassName="is-modal-seacher position-fixed modal-mobile body-no-padding"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Tipo de operaciones</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <input type="text" className="w-100 search-mobile" name="search-type" value={searcherType} placeholder={"Buscar por tipo"} onChange={(e) => setSearcherType(e.target.value)} /> */}
            <div className="float-select width-custom height-fixed py-3">
              {allSummaryData &&
              allSummaryData.objects.operation_types.find(
                (element: FilterPropertiesTokkoQuery) => element.operation_type === 1,
              ) ? (
                <div className={'flex-input '}>
                  <input
                    type="radio"
                    className="not-closer"
                    id={'venta'}
                    readOnly
                    checked={router?.operation?.toLowerCase() === 'venta' ? true : false}
                    onClick={() => {
                      setOpenLocation(false)
                      updateRoute({
                        current: { value: 'venta', name: 'operation' },
                      })
                    }}
                    value={'venta'}
                  />
                  <label
                    className="not-closer"
                    htmlFor={'venta'}
                  >
                    <div className="circle custom-span "></div>
                    <span className="mark-up not-closer py-0 my-0 ps-1">Venta</span>
                  </label>
                </div>
              ) : (
                ''
              )}
              {allSummaryData &&
              allSummaryData.objects.operation_types.find(
                (element: FilterPropertiesTokkoQuery) => element.operation_type === 2,
              ) ? (
                <div className={'flex-input '}>
                  <input
                    type="radio"
                    className="not-closer"
                    id={'alquiler'}
                    readOnly
                    checked={router?.operation?.toLowerCase() === 'alquiler' ? true : false}
                    onClick={() => {
                      setOpenLocation(false)
                      updateRoute({
                        current: { value: 'alquiler', name: 'operation' },
                      })
                    }}
                    value={'alquiler'}
                  />{' '}
                  <label
                    className="not-closer"
                    htmlFor={'alquiler'}
                  >
                    <div className="circle custom-span "></div>
                    <span className="mark-up not-closer py-0 my-0 ps-1">Alquiler</span>
                  </label>
                </div>
              ) : (
                ''
              )}
              {allSummaryData &&
              allSummaryData.objects.operation_types.find(
                (element: FilterPropertiesTokkoQuery) => element.operation_type === 3,
              ) ? (
                <div className={'flex-input '}>
                  <input
                    type="radio"
                    className="not-closer"
                    id={'temporario'}
                    checked={router?.operation?.toLowerCase() === 'temporario' ? true : false}
                    onClick={() => {
                      setOpenLocation(false)
                      updateRoute({
                        current: { value: 'temporario', name: 'operation' },
                      })
                    }}
                    readOnly
                    value={'temporario'}
                  />
                  <label
                    className="not-closer"
                    htmlFor={'temporario'}
                  >
                    <div className="circle custom-span "></div>
                    <span className="mark-up not-closer py-0 my-0 ps-1">Temporario</span>
                  </label>
                </div>
              ) : (
                ''
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div
              className="control-float position-sticky w-100 d-flex justify-content-end not-closer"
              style={{ maxWidth: 'none' }}
            >
              <button
                type="button"
                onClick={() => setShow({ ...show, operation: false })}
                className="btn btn-primary not-closer"
              >
                <label> Aplicar</label>
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal
          show={show.type}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          style={{ zIndex: 999999999 }}
          aria-labelledby="contained-modal-title-vcenter"
          contentClassName="is-modal-seacher position-fixed modal-mobile body-no-padding"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Tipos de propiedades</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <input type="text" className="w-100 search-mobile" name="search-type" value={searcherType} placeholder={"Buscar por tipo"} onChange={(e) => setSearcherType(e.target.value)} /> */}
            <div className="float-select width-custom height-fixed">
              <div className={'my-wrapper position-relative '}>
                {summaryByOperation ? (
                  <>
                    {summaryByOperation.objects.property_types.map(
                      (item: FilterPropertiesTokkoQuery, index: string) =>
                        searcherType !== '' ? (
                          <>
                            {item.type!.toLowerCase().includes(searcherType.toLowerCase()) && (
                              <div
                                key={index}
                                className={
                                  'flex-input ' +
                                  (isLoadingAllSummaryData &&
                                  !searchHome.type.find((element) => element.id === item.id)
                                    ? 'disabled '
                                    : '') +
                                  (getTypeCount(summaryByOperation.objects, item) === 0 &&
                                    'opacity-filter')
                                }
                              >
                                <input
                                  disabled={isLoadingAllSummaryData}
                                  type="checkbox"
                                  className="not-closer"
                                  name=""
                                  checked={
                                    searchHome.type.find((element) => element.id === item.id)
                                      ?.id !== undefined
                                      ? true
                                      : false
                                  }
                                  onChange={() =>
                                    updateTypes({
                                      id: item.id!,
                                      name: item.type!,
                                    })
                                  }
                                  id={item.type + '-input'}
                                  value={item.type}
                                />
                                <label
                                  className="not-closer"
                                  htmlFor={item.type + '-input'}
                                >
                                  <div className="square custom-span "></div>
                                  <div className="mark-up text-capitalize not-closer">
                                    {' '}
                                    <Markup content={toMarkup(item.type!, searcherType)} />
                                  </div>
                                </label>
                              </div>
                            )}
                          </>
                        ) : (
                          <div
                            key={index}
                            className={
                              'flex-input ' +
                              (isLoadingAllSummaryData &&
                              !searchHome.type.find((element) => element.id === item.id)
                                ? 'disabled '
                                : '') +
                              (getTypeCount(summaryByOperation.objects, item) === 0 &&
                                'opacity-filter')
                            }
                          >
                            <input
                              disabled={isLoadingAllSummaryData}
                              type="checkbox"
                              className="not-closer"
                              checked={
                                searchHome.type.find((element) => element.id === item.id)?.id !==
                                undefined
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                updateTypes({
                                  id: item.id!,
                                  name: item.type!,
                                })
                              }
                              id={item.type + '-single'}
                              value={item.type}
                            />
                            <label
                              className="not-closer"
                              htmlFor={item.type + '-single'}
                            >
                              <div className="square custom-span "></div>
                              <div className="mark-up not-closer">
                                {' '}
                                <Markup content={toMarkup(item.type!, searcherType)} />
                              </div>
                            </label>
                          </div>
                        ),
                    )}
                    {checkResults('type') && searcherType !== '' && (
                      <span className="mb-4">
                        No hay resultados sobre <b> "{searcherType}"</b>.
                      </span>
                    )}
                  </>
                ) : (
                  ''
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div
              className="control-float position-sticky w-100 d-flex justify-content-between not-closer"
              style={{ maxWidth: 'none' }}
            >
              <button
                type="button"
                onClick={() => dispatch(updateSearcherHome({ ...searchHome, type: [] }))}
                className="btn btn-primary border not-closer"
              >
                <label>Limpiar</label>
              </button>
              <button
                type="button"
                onClick={() => setShow({ ...show, type: false })}
                className="btn btn-primary not-closer"
              >
                <label> Aplicar</label>
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal
          show={show.location}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          style={{ zIndex: 999999999 }}
          aria-labelledby="contained-modal-title-vcenter"
          contentClassName="is-modal-seacher position-fixed modal-mobile body-no-padding"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Ubicaciones</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <input type="text" className="w-100 search-mobile" name="search-type" value={searcherType} placeholder={"Buscar por tipo"} onChange={(e) => setSearcherType(e.target.value)} /> */}
            <>
              <div className="float-select width-custom height-fixed">
                <div className={'my-wrapper position-relative '}>
                  {searcher !== '' ? (
                    <>
                      {getGrandfathers(dataLocations).map((item) => (
                        <>
                          {item[0].toLowerCase().includes(searcher.toLowerCase()) && (
                            <div className="hover-white d-flex px-3 w-100 align-items-center justify-content-start my-1">
                              <label className={'option flex-input not-closer'}>
                                <input
                                  checked={checkAllFatherActives(item) ? true : false}
                                  onChange={() => updateLocationByGrandFather(item)}
                                  id={item[0]}
                                  type="checkbox"
                                  className="radio-custom "
                                  value={item[0]}
                                />
                                <span className="custom-input square"></span>{' '}
                                <div className="mark-up">
                                  {' '}
                                  <Markup content={toMarkup(item[0], searcher)} />
                                </div>
                              </label>
                            </div>
                          )}
                          {getFathers(item).map((father) => (
                            <>
                              {father[0].toLowerCase().includes(searcher.toLowerCase()) && (
                                <div className="d-flex px-3 w-100 align-items-center justify-content-start py-1">
                                  <label className={'option flex-input'}>
                                    <input
                                      onChange={() => updateLocationByParent(father)}
                                      checked={
                                        checkCitiesActive(father) && !checkAllFatherActives(item)
                                          ? true
                                          : false
                                      }
                                      id={father[0]}
                                      type="checkbox"
                                      className=" radio-custom"
                                      value={father[0]}
                                    />
                                    <span className="custom-input square"></span>{' '}
                                    <div className="mark-up">
                                      {' '}
                                      <Markup content={toMarkup(father[0], searcher)} />
                                    </div>
                                  </label>
                                </div>
                              )}
                              {getChildrens(father).map(
                                (children: any) =>
                                  children[0].toLowerCase().includes(searcher.toLowerCase()) && (
                                    <div className="d-flex px-lg-3 w-100 align-items-center py-1">
                                      <label className={'option flex-input'}>
                                        <input
                                          id=""
                                          type="checkbox"
                                          checked={
                                            searchHome.location.find(
                                              (element) => element.id === children[1].id,
                                            ) && !checkAllFatherActives(item)
                                              ? true
                                              : false
                                          }
                                          onChange={() =>
                                            updateLocation({
                                              id: children[1].id,
                                              name: children[0],
                                            })
                                          }
                                          className="radio-custom"
                                          value={children[0]}
                                        />
                                        <span className="custom-input square"></span>{' '}
                                        <div className="mark-up">
                                          {' '}
                                          <Markup content={toMarkup(children[0], searcher)} />
                                        </div>
                                      </label>
                                    </div>
                                  ),
                              )}
                            </>
                          ))}
                        </>
                      ))}
                      {/* {checkResults('location') && (
            <span className="mb-4">
              No hay resultados sobre <b> "{searcher}"</b>.
            </span>
          )} */}
                    </>
                  ) : API_KEY ? (
                    getGrandfathers(dataLocations).map(
                      (
                        item,
                        i, // List the grandfathers
                      ) => (
                        <div
                          key={i}
                          className={''}
                        >
                          <div className="hover-white not-closer d-flex px-lg-3 w-100 align-items-center justify-content-start w-custom my-1 py-0 mb-0">
                            <div
                              className={'me-2 open-collapse not-closer collapsed d-inline-flex'}
                              data-bs-toggle="collapse"
                              data-bs-target={'#collapse-location-gf2-' + normalizeName(item[0])}
                            ></div>
                            <label className={'mb-0 option flex-input not-closer'}>
                              <input
                                onChange={() => updateLocationByGrandFather(item)}
                                checked={checkAllFatherActives(item) ? true : false}
                                id=""
                                type="checkbox"
                                className="radio-custom "
                                value={item[0]}
                              />
                              <span className="custom-input square"></span>{' '}
                              {item[0].replace('**(.*)**', '<b>$1</b>')}
                            </label>
                          </div>
                          <div
                            className="detail-collapse ps-4 ps-lg-0 not-height collapse "
                            id={'collapse-location-gf2-' + normalizeName(item[0])}
                          >
                            {getFathers(item).map(
                              (
                                father,
                                index, // List the fathers
                              ) => (
                                <div
                                  key={index}
                                  className="d-flex flex-column justify-content-content mb-0 align-items-start w-custom py-0"
                                >
                                  <div className="ps-2 ps-lg-5 hover-white d-flex align-items-center w-100 justify-content-center ">
                                    <div
                                      className={
                                        'me-2 not-closer open-collapse collapsed d-inline-flex ' +
                                        (getChildrens(father).length <= 1 ? ' opacity-button ' : '')
                                      }
                                      data-bs-toggle="collapse"
                                      data-bs-target={
                                        '#collapse-location-ft2-' + normalizeName(father[0])
                                      }
                                    ></div>
                                    <label className={'option not-closer flex-input'}>
                                      <input
                                        id={normalizeName(father[0])}
                                        onClick={() => updateLocationByParent(father)}
                                        checked={
                                          checkCitiesActive(father) && !checkAllFatherActives(item)
                                            ? true
                                            : false
                                        }
                                        readOnly
                                        type="checkbox"
                                        className="radio-custom"
                                      />
                                      <span className="custom-input square"></span> {father[0]}
                                    </label>
                                  </div>
                                  <div
                                    className="detail-collapse ps-5 ps-lg-0  w-100 children not-height collapse mb-2"
                                    id={'collapse-location-ft2-' + normalizeName(father[0])}
                                  >
                                    {getChildrens(father).map(
                                      (
                                        children: any,
                                        index: number, // List the childrens
                                      ) => (
                                        <label
                                          key={index}
                                          htmlFor={children[1].id}
                                          className={
                                            'childrens-inputs option hover-white flex-input'
                                          }
                                        >
                                          <input
                                            id={children[1].id}
                                            type="checkbox"
                                            checked={
                                              searchHome.location.find(
                                                (element) => element.id === children[1].id,
                                              ) && !checkAllFatherActives(item)
                                                ? true
                                                : false
                                            }
                                            onChange={() =>
                                              updateLocation({
                                                id: children[1].id,
                                                name: children[0],
                                              })
                                            }
                                            className="radio-custom"
                                            value={children[0]}
                                          />
                                          <span className="custom-input square"></span>{' '}
                                          {children[0]}
                                        </label>
                                      ),
                                    )}
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      ),
                    )
                  ) : (
                    mediacoreLocationTree?.objects?.locations_tree?.map((country: any) =>
                      country.data.map((grandfather: any, index: number) => (
                        <div
                          key={index}
                          className={''}
                        >
                          <div className="d-flex mt-2 px-lg-3 w-100 align-items-center not-closer justify-content-start w-custom">
                            <div
                              className={'me-2 open-collapse not-closer collapsed d-inline-flex'}
                              data-bs-toggle="collapse"
                              data-bs-target={
                                '#collapse-location-' + normalizeName(grandfather.name) + index
                              }
                              aria-expanded="false"
                              aria-controls={
                                'collapse-location-' + normalizeName(grandfather.name) + index
                              }
                            >
                              <div className={'symbol not-closer'}></div>{' '}
                            </div>
                            <label className={'mb-0 option flex-input not-closer'}>
                              <input
                                onChange={() => updateLocationByGrandFatherMediacore(grandfather)}
                                checked={allNeighborhoodActivesByGrandfather(grandfather)}
                                id=""
                                type="checkbox"
                                className="radio-custom not-closer "
                                name="location[]"
                                value={grandfather.name}
                              />
                              <span className="custom-input not-closer square"></span>{' '}
                              {grandfather.name.replace('**(.*)**', '<b>$1</b>')}{' '}
                            </label>
                          </div>
                          <div
                            className="detail-collapse not-height collapse not-closer "
                            id={'collapse-location-' + normalizeName(grandfather.name) + index}
                          >
                            {grandfather.data.map(
                              (
                                father: any, // List the fathers
                                index: number,
                              ) => (
                                <div
                                  key={index}
                                  className="d-flex flex-column justify-content-content mb-0 align-items-start not-closer w-custom childrens"
                                >
                                  <div className="d-flex ps-lg-4 ps-4 align-items-center w-100 justify-content-center not-closer ">
                                    <div
                                      className={
                                        'me-2 not-closer open-collapse collapsed d-inline-flex ' +
                                        (father.data.length <= 1 ? ' opacity ' : '')
                                      }
                                      data-bs-toggle="collapse"
                                      data-bs-target={
                                        '#collapse-location-' + normalizeName(father.name) + index
                                      }
                                      aria-expanded="false"
                                      aria-controls={
                                        'collapse-location-' + normalizeName(father.name) + index
                                      }
                                    >
                                      <div className={'symbol not-closer'}></div>{' '}
                                    </div>
                                    <label className={'option mb-1 not-closer flex-input'}>
                                      {/* +  updateFilters(setFilters,filters,"location", {id:father[1].id,name:father[0]}) */}
                                      <input
                                        checked={
                                          allNeighborhoodActives(father) &&
                                          !allNeighborhoodActivesByGrandfather(grandfather)
                                        }
                                        onChange={() =>
                                          updateLocationByFatherMediacore(father, grandfather)
                                        }
                                        type="checkbox"
                                        className="not-closer radio-custom"
                                        name="location[]"
                                        value={father.name}
                                      />
                                      <span className="not-closer custom-input square my-0"></span>{' '}
                                      {father.name}
                                    </label>
                                  </div>
                                  <div
                                    className="detail-collapse ps-5 children not-height collapse not-closer mb-2 childrens"
                                    id={'collapse-location-' + normalizeName(father.name) + index}
                                  >
                                    {father.data.map(
                                      (
                                        children: any, // List the childrens
                                        index: number,
                                      ) => (
                                        <label
                                          key={index}
                                          className={'not-closer ps-3 mb-1 option flex-input'}
                                        >
                                          <input
                                            id=""
                                            type="checkbox"
                                            checked={
                                              filters.location.find(
                                                (element) => element.name === children.name,
                                              )
                                                ? true
                                                : false
                                            }
                                            onChange={() =>
                                              updateLocationByChildrenMediacore(children)
                                            }
                                            className="not-closer radio-custom"
                                            name="location[]"
                                            value={children.name}
                                          />
                                          <span className="not-closer  custom-input square my-0"></span>{' '}
                                          {children.name}
                                        </label>
                                      ),
                                    )}
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      )),
                    )
                  )}
                </div>
              </div>
            </>
          </Modal.Body>
          <Modal.Footer>
            <div
              className="control-float position-sticky w-100 d-flex justify-content-between not-closer"
              style={{ maxWidth: 'none' }}
            >
              <button
                type="button"
                onClick={() => dispatch(updateSearcherHome({ ...searchHome, location: [] }))}
                className="btn btn-primary border not-closer"
              >
                <label>Limpiar</label>
              </button>
              <button
                type="button"
                onClick={() => setShow({ ...show, location: false })}
                className="btn btn-primary not-closer"
              >
                <label> Aplicar</label>
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    )
  )
}

const AddresAutocomplete = ({
  iconsStyle,
  API_KEY,
  handleTogglerSelect,
  alignLeft,
}: {
  iconsStyle: string
  API_KEY: string
  handleTogglerSelect: Function
  alignLeft: boolean
}) => {
  const [searchtext, setSearchtext] = useState('')
  const [suggest, setSuggest] = useState([])
  const [resfound, setResfound] = useState(true)
  const [listTextGenerated, setListTextGenerated] = useState<any>([])

  const [disabledPlaceholder, setDisabledPlaceholder] = useState(false)

  const searchHome = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties.searchHome,
  )!

  const { properties, isFetching } = useQuerySearcher({
    filters: searchHome,
    tokkoKey: API_KEY,
  })

  const dispatch = useDispatch()

  const [show, setShow] = useState(false)

  const [closed, setClosed] = useState(false)

  const miInputRef = useRef(null)

  const handleChange = (e: any) => {
    setClosed(false)
    let searchval = e.target.value
    setSearchtext(searchval)
  }

  const suggestedText = (value: string) => {
    setSearchtext(value.split(' | ')[0])
    setShow(false)
    setSuggest([])
  }

  useEffect(() => {
    setListTextGenerated(groupPropertiesFunction()?.texts_results)
    let suggestion = []
    suggestion = listTextGenerated.sort()
    if (searchtext.length > 2) {
      setResfound(suggestion.length !== 0 ? true : false)
      setSuggest(suggestion)
    }
  }, [properties])

  useEffect(() => {
    let suggestion = []
    suggestion = listTextGenerated.sort()
    if (searchtext.length > 2) {
      setResfound(suggestion.length !== 0 ? true : false)
      setSuggest(suggestion)
    }
  }, [listTextGenerated])

  const groupPropertiesFunction = () => {
    let results = []
    let texts_results = []
    results.push({ fake_address: searchtext, count: properties?.objects?.length })
    for (let i = 0; i < properties?.objects?.length!; i++) {
      if (results.find((element) => element.fake_address === properties?.objects[i].fake_address)) {
        let same: any = results.find(
          (element) => element.fake_address === properties?.objects[i].fake_address,
        )
        same.count += 1
        results = [
          ...results.filter(
            (result) => result.fake_address !== properties?.objects[i].fake_address,
          ),
          same,
        ]
      } else {
        results.push({ fake_address: properties?.objects[i].fake_address, count: 1 })
      }
    }
    results = results.sort(function (a, b) {
      return b.count - a.count
    })

    for (let i = 0; i < results.length; i++) {
      // if(searchtext.length > 2){
      if (i < 4) {
        texts_results.push(results[i].fake_address + ' | ' + results[i].count + ' resultados')
      }
      // }
    }
    return { results, texts_results }
  }

  useEffect(() => {
    setListTextGenerated([])
    const timeoutId = setTimeout(() => {
      dispatch(updateSearcherHome({ ...searchHome, address: searchtext }))
    }, 25) // Espera 1 segundo (1000 milisegundos)
    return () => clearTimeout(timeoutId)
  }, [searchtext])

  function toMarkup(text: string, value: string) {
    if (value === '') {
      return text.toLowerCase()
    }
    text = text.toLowerCase().replaceAll(value.toLowerCase(), '<b>' + value.toLowerCase() + '</b>')
    return text
  }

  const sortSuggest = (suggest: string[]) => {
    let order_suggest: any = []
    for (const result of groupPropertiesFunction().results) {
      const finder = suggest.find(
        (element) => element.toLowerCase().split(' | ')[0] == result.fake_address.toLowerCase(),
      )
      if (finder) {
        order_suggest.push(finder)
      }
    }
    return order_suggest
  }

  const getSuggestions = () => {
    if (suggest.length === 0 && searchtext !== '' && !resfound) {
    }

    return (
      <ul className={searchtext.length > 2 && !closed ? 'd-block' : 'd-none'}>
        {isFetching ? (
          <div className="d-flex align-items-center w-100 hover-color">
            <li>Cargando resultados..</li>
          </div>
        ) : (
          sortSuggest(suggest).map((item: any, index: number) => {
            return (
              <div
                key={index}
                className="d-flex align-items-center w-100 hover-color"
              >
                <li
                  onClick={() => {
                    suggestedText(item)
                    setClosed(true)
                  }}
                >
                  {}
                  <Markup content={toMarkup(item, searchtext)} />
                </li>
                {index !== suggest.length - 1 && <hr />}
              </div>
            )
          })
        )}
      </ul>
    )
  }

  return (
    <div className="searchcontainer d-lg-flex">
      <div
        onClick={() => toast.error('Debes primero seleccionar un tipo de operación.')}
        className={'z-index-top ' + (searchHome.operation === '' ? 'd-block' : 'd-none')}
      ></div>
      <i className={'icon-location' + iconsStyle}></i>
      <input
        type="text"
        placeholder={disabledPlaceholder ? '' : 'Buscar por calle o avenida'}
        className={`searcher-address no-hover text-start br-true true  ${
          alignLeft ? 'left-alignment' : ''
        }`}
        id="your-field"
        value={searchHome.address}
        onClick={() => handleTogglerSelect('')}
        onChange={handleChange}
        onFocus={() => setDisabledPlaceholder(true)}
        onBlur={() => setDisabledPlaceholder(false)}
      />
      {getSuggestions()}
      <Modal
        className="modal-pro address"
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        keyboard={false}
        aria-labelledby="contained-modal-title-vcenter"
        contentClassName="modal-mobile"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Buscar por calle o avenida</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            placeholder="Buscar por calle o avenida"
            className="search search-mobile w-100"
            id="your-field"
            ref={miInputRef}
            value={searchHome.address}
            onChange={handleChange}
          />
          {getSuggestions()}
        </Modal.Body>
        <Modal.Footer>
          <div className="control-float float-home position-sticky w-100 d-flex justify-content-between not-closer">
            <input className="btn btn-primary border not-closer">Limpiar</input>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default Search_1
